







import {Component, Vue, Prop} from 'vue-property-decorator'
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import UserTimeEntriesList from '@/components/UserTimeEntriesList.vue';
import { User } from '@/models/user';

@Component({
    name: 'UserTimeEntries',
    components: {
        UserTimeEntriesList,
        NotLoggedPanel
    }
})
export default class UserTimeEntries extends Vue{
    @Prop() private user!: User;

}
